import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';


export const fetchEmployeePerformanceOverview = createAsyncThunk(
    'employeePerformanceOverview/fetchEmployeePerformanceOverview',
    async (organizationId, { rejectWithValue }) => {
        const jwtToken = localStorage.getItem("jwt_token");
        const URL = `${process.env.REACT_APP_API_URL}/leaderboard`;
        try {
            const response = await axios.get(`${URL}/${organizationId}`, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${jwtToken}`,
                },
            });
            return response.data.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

const leaderboardSlice = createSlice({
    name: 'employeePerformanceOverview',
    initialState: {
        data: [],
        loading: false,
        error: null,
    },
    reducers: {
        clearEmployeePerformanceOverview: (state) => {
            state.data = [];
            state.error = null;
            state.loading = false;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchEmployeePerformanceOverview.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchEmployeePerformanceOverview.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchEmployeePerformanceOverview.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const { clearEmployeePerformanceOverview } = leaderboardSlice.actions;
export default leaderboardSlice.reducer;
